"use client"

import { useState, useEffect } from "react"

interface CountdownTimerProps {
  targetDate: Date
  quaternaryColor?: string
}

export default function CountdownTimer({ targetDate, quaternaryColor = "#343a40" }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const calculateTimeLeft = () => {
      // Create a date object representing current time in São Paulo (UTC-3)
      const now = new Date()
      const saoPauloOffset = -3 * 60 // São Paulo is UTC-3 (in minutes)
      const localOffset = now.getTimezoneOffset() // Local timezone offset in minutes
      const offsetDifference = localOffset + saoPauloOffset
      const saoPauloTime = new Date(now.getTime() + offsetDifference * 60 * 1000)

      const difference = +targetDate - +saoPauloTime

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        })
      } else {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        })
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  return (
    <div className="flex justify-center space-x-4 md:space-x-8">
      <div className="flex flex-col items-center">
        <div
          className="text-2xl md:text-4xl font-bold backdrop-blur-sm bg-white/10 rounded-lg px-3 py-2 border border-white/20"
          style={{ color: quaternaryColor }}
        >
          {String(timeLeft.days).padStart(2, "0")}
        </div>
        <div className="text-xs md:text-sm uppercase tracking-wider" style={{ color: quaternaryColor }}>
          Dias
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div
          className="text-2xl md:text-4xl font-bold backdrop-blur-sm bg-white/10 rounded-lg px-3 py-2 border border-white/20"
          style={{ color: quaternaryColor }}
        >
          {String(timeLeft.hours).padStart(2, "0")}
        </div>
        <div className="text-xs md:text-sm uppercase tracking-wider" style={{ color: quaternaryColor }}>
          Horas
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div
          className="text-2xl md:text-4xl font-bold backdrop-blur-sm bg-white/10 rounded-lg px-3 py-2 border border-white/20"
          style={{ color: quaternaryColor }}
        >
          {String(timeLeft.minutes).padStart(2, "0")}
        </div>
        <div className="text-xs md:text-sm uppercase tracking-wider" style={{ color: quaternaryColor }}>
          Min
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div
          className="text-2xl md:text-4xl font-bold backdrop-blur-sm bg-white/10 rounded-lg px-3 py-2 border border-white/20"
          style={{ color: quaternaryColor }}
        >
          {String(timeLeft.seconds).padStart(2, "0")}
        </div>
        <div className="text-xs md:text-sm uppercase tracking-wider" style={{ color: quaternaryColor }}>
          Seg
        </div>
      </div>
    </div>
  )
}
